var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"journal-filters-module module module--mb"},[_c('div',{staticClass:"container"},[_c('TextHeaderComponent',{attrs:{"p":_vm.p}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }